import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import FIELDS from '../data/fields';
import InputComponent from '../components/elements/input';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';
import HeaderComponent from '../components/table/header/headerComponent';
import DropZoneComponent from '../components/dropzone';
import TextArea from '../components/elements/textArea';
import AccessProfilesAction from '../app/store/actions/accessProfiles';
import VALIDATOR from '../helpers/validator/formValidator';

import randomPassword from '../helpers/generator';

// const helper = '';
class AccessProfilesForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      profile: '',
      description: '',
      message: '',
      success: '',
      active: true,      
      isUpdate: false,
      loadImage: false
    };
  }

  async componentDidMount() {
    if (this.props.location.search) {
      const { search } = this.props.location;
      const splited = search.split('=');
      const id = splited[1];
      await this.props.getAccessProfile(id);
      const {
        description, profile, active,
      } = this.props.accessProfile;
      await this.setState({
        id, description, profile, active, isUpdate: true,
      });
    }
  }

  goBack = () => {
    history.push(ROUTES.ACCESS_PROFILE);
  } 

  createAccessProfile = async () => {
    const {
      profile, description
    } = this.state;

    const valid = VALIDATOR.accessProfileValidator({ profile, description });
    if (valid.success) {
      await this.props.createAccessProfile({
        profile, description, code: "", active: true,
      });
      await this.setState({
        message: '',
        success: I18n.t('accessProfileCreated'),
        id: '',
        profile: '',
        description: '',
        active: true,
      });
      this.goBack();
    } else {
      await this.setState({ message: valid.message, success: '' });
    }

  }

  updateAccessProfile = async () => {
    const {
      profile, description, id, active,
    } = this.state;

    const valid = VALIDATOR.accessProfileValidator({ profile, description });
    if (valid.success) {
      await this.props.updateAccessProfile({
        profile, description, active, id,
      });
      await this.setState({ message: '', success: I18n.t('accessProfileUpdated') });
    } else {
      await this.setState({ message: valid.message, success: '' });
    }
  }

  render() {
    const {
      profile,
      description,
      id,
      message,
      success,
      loadImage,
      isUpdate,
      file,
    } = this.state;

    return (
      <div className="main-table">
        <HeaderComponent
          title={I18n.t('accessProfileRegister')}
        />
        
        <div className="form-group search-custom-input">
          <p className="margin-bottom-2"><Translate value="profile" /></p>
          <InputComponent
            type="text"
            className="form-control"
            placeHolder=""
            onChange={e => this.setState({ profile: e.target.value })}
            value={profile}
            maxLength={FIELDS.max}
          />          
          <TextArea
            title={I18n.t('description')}
            onChange={e => this.setState({ description: e.target.value })}
            value={description}
            maxLength=""
            placeHolder=""
            rows={3}
          />
          <button
            type="button"
            onClick={this.goBack}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>
          {id
            ? (
              <button
                type="button"
                className="btn btn-dark margin"
                onClick={this.updateAccessProfile}
              >
                <Translate value="update" />
              </button>
            )
            : (
              <button
                type="button"
                className="btn btn-dark"
                onClick={this.createAccessProfile}
              >
                <Translate value="register" />
              </button>
            )
          }
          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getAccessProfile: id => dispatch(AccessProfilesAction.getAccessProfile(id)),
  updateAccessProfile: accessProfile => dispatch(AccessProfilesAction.updateAccessProfile(accessProfile)),
  createAccessProfile: accessProfile => dispatch(AccessProfilesAction.createAccessProfile(accessProfile)),
});

const mapStateToProps = state => ({
  accessProfile: state.accessProfiles && state.accessProfiles.accessProfile,
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessProfilesForm);
